import { combineReducers } from "redux";
import authentication from './Ducks/duckAuth.js'
import questions from './Ducks/Question/duckQuestion.js'
import masterData from "./Ducks/masterData/duckMasterData.js";
import societies from "./Ducks/duckSocieties.js";
import countries from "./Ducks/duckCountries.js";
import documentType from "./Ducks/duckDocumentType.js";
import currencies from "./Ducks/duckCurrencies.js";
import document from "./Ducks/duckDocument.js";
import documentXml from "./Ducks/duckDocumentXml";
import reason from "./Ducks/duckReason.js";
import supplier from "./Ducks/duckSupplier.js";
import tickets from "./Ducks/duckTickets.js";
import ticketsComments from "./Ducks/duckTicketsComments";
import voucherDocument from "./Ducks/duckVoucherDocument.js";

const reducers = combineReducers({
    authentication, 
    currencies,  
    countries,
    documentType,     
    masterData,
    questions,
    societies,   
    document,
    documentXml,
    reason,    
    supplier,
    tickets,
    ticketsComments,
    voucherDocument
});
export default reducers;